import { NextButton, PrevButton, usePrevNextButtons } from "components/UI/CarouselArrowButtons";
import useEmblaCarousel from "embla-carousel-react";

export default function TransparencyCarousel({ children }) {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: false,
    align: "start",
    slidesToScroll: 1,
  });

  const { prevBtnDisabled, nextBtnDisabled, onPrevButtonClick, onNextButtonClick } =
    usePrevNextButtons(emblaApi);

  return (
    <div>
      <div className="relative">
        <div className="overflow-hidden" ref={emblaRef}>
          <div className="flex">
            {children?.map((child, index) => (
              <div key={index} className="flex-[0_0_auto] w-full px-2">
                {child}
              </div>
            ))}
          </div>
        </div>
      </div>

      {children?.length > 1 && (
        <div className="flex justify-start items-center pt-8">
          <div className="gap-4 flex">
            <PrevButton onClick={onPrevButtonClick} disabled={prevBtnDisabled} />
            <NextButton onClick={onNextButtonClick} disabled={nextBtnDisabled} />
          </div>
        </div>
      )}
    </div>
  );
}
